import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from '../../../../global.service';

import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';


@Component({
  selector: 'app-covid19-advice',
  templateUrl: './covid19-advice.component.html',
  styleUrls: ['./covid19-advice.component.css']
})
export class Covid19AdviceComponent implements OnInit {

  language: any;
  langChosen: string = 'en';

  public config: PerfectScrollbarConfigInterface = {
    // suppressScrollX:true
  };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;


  constructor( public globalService: GlobalService) { }

  ngOnInit() {

    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('../../../../dictionary/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('../../../../dictionary/en.json');
      }
    }
  }

}
